<template>
  <div class="owal env ui container">
    <owal-panel title="Faces Stats" class="owal env ui panel">
      <div v-if="statsLoaded" class="stats_container">
        <section class="stat">
          <header class="stat"># Detections (past 24 hours)</header>
          <article class="stat"><h1>{{stats.rawFacesDetected.toLocaleString()}}</h1></article>
        </section>
        <section class="stat">
          <header class="stat"># Faces (past 24 hours)</header>
          <article class="stat"><h1>{{stats.facesDetected.toLocaleString()}}</h1></article>
        </section>
        <section class="stat">
          <header class="stat"># Matches (past 24 hours)</header>
          <article class="stat"><h1>{{stats.facesMatched.toLocaleString()}}</h1></article>
        </section>
       <section class="stat">
          <header class="stat">Match rate (past 24 hours)</header>
          <article class="stat"><h1>{{percentage}}%</h1></article>
        </section>
      </div>
      <div v-if="avgStatsLoaded" class="stats_container">
        <section class="stat">
          <header class="stat">Avg # Daily Detections (past 7 days)</header>
          <article class="stat"><h1>{{avgStats.rawFacesDetected.toLocaleString()}}</h1></article>
        </section>
        <section class="stat">
          <header class="stat">Avg # Daily Faces (past 7 days)</header>
          <article class="stat"><h1>{{avgStats.facesDetected.toLocaleString()}}</h1></article>
        </section>
        <section class="stat">
          <header class="stat">Avg # Daily Matches  (past 7 days)</header>
          <article class="stat"><h1>{{avgStats.facesMatched.toLocaleString()}}</h1></article>
        </section>
       <section class="stat">
          <header class="stat">Avg Daily Match Rate (past 7 days)</header>
          <article class="stat"><h1>{{avgPercentage}}%</h1></article>
        </section>
      </div>
      <div v-if="maskStatsLoaded" class="masks_container">
        <header class="stat">Mask trends in detections</header>
        <apexchart
          class="apexcharts"
          height="350"
          :options="maskChartOptions"
          :series="maskSeries"
        >
        </apexchart>
      </div>
      <div v-if="maskStatsLoaded" class="masks_container">
        <header class="stat">Mask wearing percentage over time</header>
        <apexchart
          class="apexcharts"
          height="350"
          :options="maskPercentageChartOptions"
          :series="maskPercentageSeries"
        >
        </apexchart>
      </div>
    </owal-panel>
  </div>
</template>

<script>
import OwalPanel from '@/libraries/owal-ui/panels/OwalPanel'
import { loadFacesStats, loadMaskStats } from '@/libraries/api/faces'
import { mapGetters } from 'vuex'
import VueApexCharts from 'vue-apexcharts'
export default {
  name: 'FacesStats',
  components: {
    OwalPanel,
    apexchart: VueApexCharts,
  },
  data: () => {
    return {
      stats: {},
      avgStats: {},
      maskStats: [],
      statsLoaded: false,
      maskStatsLoaded: false,
      avgStatsLoaded: false,
    }
  },
  methods: {
    async loadStats () {
      let [stats, avgs] = await Promise.all([loadFacesStats(this.currentDomainUUID), loadFacesStats(this.currentDomainUUID, '&days=7')])
      this.statsLoaded = true
      this.stats = stats.data.data
      console.log(`loaded stats ${this.stats}`)
      const avgStats = avgs.data.data
      this.avgStatsLoaded = true
      this.avgStats = avgStats
      console.log(`loaded avg stats ${this.avgStats}`)
    },
    async loadMaskStats() {
      const { data } = await loadMaskStats(this.currentDomainUUID, 7)
      const maskStats = data.data
      this.maskStatsLoaded = true
      this.maskStats = maskStats.map(stat => ({ ...stat, hour: new Date(stat.hour) }))
      this.now = new Date()
      console.log(`loaded mask stats ${JSON.stringify(this.maskStats)}`)
    },
    formatHour(date) {
      return date.toLocaleTimeString('en-US', { month: 'short', day: 'numeric', hour: 'numeric' })
    },
  },
  async created() {
    try {
      await Promise.all([
        await this.loadStats(),
        await this.loadMaskStats(),
      ])
    } catch (e) {
      console.error(`${e}`)
    }
  },
  watch: {
    currentDomainUUID: async function (val, oldVal) {
      try {
        await Promise.all([
          await this.loadStats(),
          await this.loadMaskStats(),
        ])
      } catch (e) {
        console.error(`${e}`)
      }
    },
  },
  computed: {
    ...mapGetters({
      currentDomainUUID: 'currentDomainUUID',
    }),
    percentage () {
      if (this.stats.facesMatched && this.stats.facesDetected && this.stats.facesDetected > 0) {
        return ((this.stats.facesMatched / this.stats.facesDetected) * 100).toFixed(2)
      } else {
        return ''
      }
    },
    avgPercentage () {
      if (this.avgStats.facesMatched && this.avgStats.facesDetected && this.avgStats.facesDetected > 0) {
        return ((this.avgStats.facesMatched / this.avgStats.facesDetected) * 100).toFixed(2)
      } else {
        return ''
      }
    },
    maskSeries () {
      const masks = this.maskStats.filter(s => s.hour > (this.now - 60 * 60 * 24 * 1000)).map(s => s.masks)
      const notMasks = this.maskStats.filter(s => s.hour > (this.now - 60 * 60 * 24 * 1000)).map(s => s.noMasks)
      return [
        { name: 'mask', data: masks },
        { name: 'no mask', data: notMasks },
      ]
    },
    maskPercentageSeries() {
      const maskPercentage = this.maskStats.map(s => s.percentage)
      return [
        { name: 'mask percentage', data: maskPercentage },
      ]
    },
    maskPercentageChartOptions() {
      return {
        chart: {
          type: 'area',
          stacked: false,
          background: '#2c3e50',
          height: 350,
          zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true,
          },
          toolbar: {
            autoSelected: 'zoom',
          },
        },
        xaxis: {
          categories: this.maskStats.map(s => this.formatHour(s.hour)),
        },
        yaxis: {
          labels: {
            formatter: value => (value * 100).toFixed() + '%',
          },
        },
        dataLabels: {
          enabled: false,
        },
        theme: {
            mode: 'dark',
        },
      }
    },
    maskChartOptions () {
      return {
        chart: {
          type: 'bar',
          stacked: true,
          background: '#2c3e50',
          id: 'vuechart-example',
        },
        xaxis: {
          categories: this.maskStats.filter(s => s.hour > (this.now - 60 * 60 * 24 * 1000)).map(s => this.formatHour(s.hour)),
        },
        theme: {
          mode: 'dark',
        },
      }
    },
  },
}
</script>

<style scoped>
.owal.env.ui.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.owal.env.ui.panel {
  /* max-width: 68.5714285714rem; */
  margin: 1rem;
  max-height: 90%;
  max-width: 90vw;
  width: stretch;
  overflow: auto;
}

.owal.panel.active.window >>> .owal.panel.container {
  display: block;
}
.stats_container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto;

  align-content: center;
  grid-gap: 1rem;
  margin: 1rem;
}
.stat {
  text-align: center;
  color: white;
}
section.stat {
  border-radius: 1rem;
  overflow: hidden;
}
header.stat {
  background: #829eba;
  padding: .5rem 1.5rem .5rem 1.5rem;
}
article.stat {
  padding: 1.5rem;
  background: #2c3e50;
}
.masks_container {
  border-radius: 1rem;
  overflow: hidden;
  margin: 1rem;
}
.inner_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.apexcharts {
  min-height: 350px !important;
}
</style>
